module.exports = __webpack_public_path__ + "img/ls-dyna.862490ef.png";